export default __webpack_public_path__ + "static/media/SeminarioIes2026_DanielSalinas.0b83328e.jpg";